import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import { Routes, Route, Link } from "react-router-dom";

import NavBar from './components/NavBar';
import Home from './routes/Home';
import LoginForm from './components/LoginForm';
import About from './routes/About';
import { useAuth } from './contexts/auth';
import JokeType from './routes/JokeType';
import PrivacyPolicy from './routes/PrivacyPolicy';
import Login from './routes/Login';


function App() {

  const { user, login, logout, authentication } = useAuth();

  useEffect(() => {
    authentication()

  }, [])

  return (
    <div className="App">
      {
        user ?
          <>
            <NavBar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="jokeType/:jokeTypeId" element={<JokeType />} />

            </Routes>
          </>
          :
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<PrivacyPolicy />} />

          </Routes>

      }


    </div>
  );
}

export default App;


